// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router'
import * as Cookie from '@/utils/cookie'
import * as Utils from '@/utils/utils'
import * as Filter from './utils/filter'

Vue.use(Vant);

Vue.config.productionTip = false;

var token = Utils.getUrlParam('token')
Cookie.setToken(token)

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

Object.keys(Filter).forEach(key => {
  Vue.filter(key, Filter[key])
})

const vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

export default vm




// WEBPACK FOOTER //
// ./src/main.js